import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export const isValidCID = (id: string) => {
    if (id == null || id.length !== 13 || !/^[0-9]\d+$/.test(id)) {
        return false
    }
    let i
    let sum = 0
    for (i = 0, sum = 0; i < 12; i += 1) {
        sum += parseInt(id.charAt(i), 10) * (13 - i)
    }
    const check = (11 - (sum % 11)) % 10
    if (check === parseInt(id.charAt(12), 10)) {
        return true
    }
    return false
}
 
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}